import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import { CollapseBlock } from "ComponentsUI/CollapseBlock";

const styles = theme => {
    return {
        block: {
            "&:last-child": {
                marginBottom: 0,
            },
        },
        contactsBlock: {},
        contactsBlockItem: {
            marginBottom: "28px",
            "&:last-child": {
                marginBottom: 0,
            },
        },
        contactsBlockItemText: {
            fontFamily: theme.fonts.medium,
            fontSize: "14px",
            lineHeight: 1.29,
            letterSpacing: "2px",
            color: theme.palette.colors.oneMoreGrey,
            textTransform: "uppercase",
            marginBottom: "8px",
        },
        contactsBlockItemValue: {
            fontFamily: theme.fonts.bold,
            fontSize: "16px",
            lineHeight: 1.25,
            color: theme.palette.colors.darkSlateBlue,
            flexShrink: 100,
        },
        isLink: {
            color: theme.palette.colors.purplishBlue,
            textDecoration: "underline",
        },
        partnersLink: {
            fontFamily: theme.fonts.bold,
            fontSize: "16px",
            lineHeight: 1.25,
            color: theme.palette.colors.darkSlateBlue,
            flexShrink: 100,
            borderBottom: `1px dashed ${theme.palette.colors.darkSlateBlue}`,
        },
        [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
            contactsBlockItemText: {
                width: "160px",
            },
        },
        [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
            contactsBlockItemText: {
                width: "210px",
            },
            contactsBlockItemValue: {},
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            contactsBlockItem: {
                marginBottom: "10px",
            },
            contactsBlockItemText: {
                width: "auto",
                fontSize: "12px",
                lineHeight: 1.5,
                letterSpacing: "1.7px",
            },
            contactsBlockItemValue: {
                fontSize: "14px",
                lineHeight: 1.29,
            },
            partnersLink: {
                fontSize: "14px",
                lineHeight: 1.29,
            },
        },
        [`@media (max-width: 420px)`]: {
            contactsBlockItem: {
                marginBottom: "10px",
                flexWrap: "wrap",
            },
            contactsBlockItemText: {
                fontSize: "12px",
                lineHeight: 1.5,
                letterSpacing: "1.7px",
            },
            contactsBlockItemValue: {
                fontSize: "14px",
                lineHeight: "1.29",
                marginTop: "2px",
            },
            partnersLink: {
                fontSize: "14px",
                lineHeight: "1.29",
                marginTop: "2px",
            },
        },
    };
};

class ProviderInfoBlock extends React.PureComponent {
    render() {
        const text = this.props.texts;
        const classes = this.props.classes;
        const provider = this.props.provider;
        return (
            <div
                itemScope
                itemType="http://schema.org/Organization"
                className={classNames(classes.contactsBlock, classes.block)}
            >
                <meta itemProp="name" content={provider.name} />
                <link itemProp="url" href={`http://${this.props.site}`} />
                <meta
                    itemProp="telephone"
                    content={provider.contacts.phones[0]}
                />
                <meta itemProp="logo" content={`http:${provider.logo}`} />
                <div
                    className={classes.contactsBlockItem}
                    itemProp="address"
                    itemScope
                    itemType="http://schema.org/PostalAddress"
                >
                    <meta itemProp="addressCountry" content={text.RUSSIA} />
                    <meta
                        itemProp="streetAddress"
                        content={`${this.props.street} ${this.props.homeOffice}`}
                    />
                    <div className={classes.contactsBlockItemText}>
                        {text.TOWN}
                    </div>
                    <div
                        className={classes.contactsBlockItemValue}
                        itemProp="addressLocality"
                    >
                        {this.props.city}
                    </div>
                </div>
                {!!this.props.street && (
                    <div className={classNames(classes.contactsBlockItem)}>
                        <div className={classes.contactsBlockItemText}>
                            {text.MAIN_OFFICE}
                        </div>
                        <div
                            href={`http:${this.props.site}`}
                            target="_blank"
                            className={classNames(
                                classes.contactsBlockItemValue
                            )}
                        >
                            {`${this.props.street ? this.props.street : ""} ${
                                this.props.homeOffice
                                    ? this.props.homeOffice
                                    : ""
                            }`}
                        </div>
                    </div>
                )}
                {!!this.props.nameLegal && (
                    <div className={classNames(classes.contactsBlockItem)}>
                        <div className={classes.contactsBlockItemText}>
                            {text.LEGAL_NAME}
                        </div>
                        <div
                            itemProp="legalName"
                            className={classNames(
                                classes.contactsBlockItemValue
                            )}
                        >
                            {this.props.nameLegal}
                        </div>
                    </div>
                )}
                <CollapseBlock
                    header={text.menuOther}
                    small={true}
                    windowSize={this.props.windowSize}
                >
                    {!!this.props.phones && (
                        <div
                            itemProp="contactPoint"
                            itemScope
                            itemType="http://schema.org/ContactPoint"
                            className={classes.contactsBlockItem}
                        >
                            <meta
                                itemProp="telephone"
                                content={provider.contacts.phones[0]}
                            />
                            <meta
                                itemProp="contactType"
                                content="customer service"
                            />
                            <link
                                itemProp="url"
                                href={`http://${this.props.currentUrl}`}
                            />
                            <div className={classes.contactsBlockItemText}>
                                {text.SALES_DEPARTMENT}
                            </div>
                            <div
                                itemProp="telephone"
                                className={classNames(
                                    classes.contactsBlockItemValue
                                )}
                            >
                                {this.props.cardType == 3 ? (
                                    <a
                                        className={classes.partnersLink}
                                        href={this.props.link}
                                        target="_blank"
                                    >
                                        {text.CONTACT_PROVIDER}
                                    </a>
                                ) : (
                                    this.props.phones
                                )}
                            </div>
                        </div>
                    )}
                    {!!this.props.phoneSupport && (
                        <div className={classNames(classes.contactsBlockItem)}>
                            <div className={classes.contactsBlockItemText}>
                                {text.SUPPORT}
                            </div>
                            <div
                                itemProp="telephone"
                                className={classNames(
                                    classes.contactsBlockItemValue
                                )}
                            >
                                {this.props.phoneSupport}
                            </div>
                        </div>
                    )}
                    {this.props.site && (
                        <div className={classNames(classes.contactsBlockItem)}>
                            <div className={classes.contactsBlockItemText}>
                                {text.OFFICIAL_SITE}
                            </div>
                            <div
                                className={classNames(
                                    classes.contactsBlockItemValue
                                )}
                            >
                                {this.props.site}
                            </div>

                            {/*
                        <
                            a
                            href = {`http://${
                                this.props.site
                            }`
                        }
                            rel = "nofollow"
                            target = "_blank"
                            datatest = "proveders_providersyte_button"
                            className = {
                                classNames(
                                    classes.contactsBlockItemValue
                        )
                        }
                        >
                            {
                                this.props.site
                            }
                        <
                            /a>
                        */}
                        </div>
                    )}
                </CollapseBlock>
            </div>
        );
    }
}

export default withStyles(styles)(ProviderInfoBlock);
